import React, { Component } from 'react';
import { StyleSheet, View, Text, Image, TouchableOpacity } from 'react-native';
import { Row, Rows } from '../../components/Rows';
import { Table } from '../../components/Table';
import images from "../../images/ImagesControl";

class Content1 extends Component {
	render() {
		return (
			<View>
				<Text style={styles.heading}>
					{
						"Creating Module Data with SqlEntity"
					}
				</Text>
				<Text style={styles.text}>
					{
						"From last chapter, you should be familiar with our basic Web Service in obtaining the required information for filling in a "
					}
					<Text style={{ fontStyle: 'iTalic' }}>
						{
							"SqlEntity."
						}
					</Text>
				</Text>
				<Text style={styles.subheading}>
					{
						"Aim:"
					}
				</Text>
				<Text style={styles.text}>
					{
						"After reading this chapter, you should be able to:"
					}
				</Text>
				<Text style={[styles.text, { paddingLeft: 20 }]}>
					{
						"1.	Create a module record through Web Service"
					}
				</Text>
				<Text style={[styles.text, { paddingLeft: 20 }]}>
					{
						"2.	Understand Data Dictionary in M18"
					}
				</Text>
				<Text style={styles.subheading}>
					{
						"Scenario:"
					}
				</Text>
				<Text style={[styles.text, { paddingBottom: 20 }]}>
					{
						"Chris Wong is IT Manager of ABC Fruit Company. Customers can order fruits from the Online Shop:"
					}
				</Text>
			</View>
		)
	}
}

class Content2 extends Component {
	constructor(props) {
		super(props);
		this.state = {
			heightArr: [40, 40, 40, 40, 40, 40, 60],
			widthArr: [110, 150, 430],
			tableHead: ["Name", "Type", "Description"],
			tableData: [
				["authorization", "String(Header)", "Required. Access Token obtained via OAuth"],
				["client_id", "String(Header)", "Required. Client ID in M18 [OAuth Applications]"],
				["module", "String(Path)", "Required. Module name ,such as 'employee', can be found in data dictionary."],
				["menuCode", "String(Query)", "Required. Menu code, such as 'employee', can be found in data dictionary."],
				["param", "jsonString(Query)", "Additional parameters for special actions."],
				["entity", "jsonString(Query)", "The Simplified Entity JSON, structure please refer to the below. Notice that the JSON need to be URL Encoded."],
				["entitys_in_entity", "String(Body)", "The Simplified Entity JSON, structure please refer to the below. It is recommended to pass entity JSON in request body.If you want to handle more entitys, please pass an array of Simplified Entity JSON."],
			],
		};
	}

	render() {
		const state = this.state;

		return (
			<View>
				<Text style={styles.text}>
					{
						"Chris collects orders received from online shop every day and passes data to Sales Department for data entry into M18 ERP System. Manager of Sales Department complaints that data volume is too huge. It is very time consuming to input data manually. Other than using importation provided in M18 ERP System, Chris decides to automate this process with the help of "
					}
					<Text style={{ fontStyle: 'iTalic' }}>
						{
							"SqlEntity Web Service."
						}
					</Text>
				</Text>
				<Text style={styles.subheading}>
					{
						"Documentation for SqlEntity Save:"
					}
				</Text>
				<Text style={[styles.text, { fontWeight: 'bold' }]}>
					{
						"HTTP Request"
					}
				</Text>
				<Text style={[styles.text, { color: 'red' }]}>
					{
						"PUT http://[server]/jsf/rfws/entity/s/save/[module]?menuCode=[menuCode]"
					}
				</Text>
				<Text style={[styles.text, { fontWeight: 'bold' }]}>
					{
						"Parameters"
					}
				</Text>
				<Table borderstyle={{ borderWidth: 1 }} style={{ paddingTop: 20 }}>
					<Row data={state.tableHead} style={styles.tableCell}
						widthArr={state.widthArr} textStyle={[styles.tableText, { fontWeight: 'bold' }]} />
					<Rows data={state.tableData} style={styles.tableCell}
						widthArr={state.widthArr} textStyle={styles.tableText} heightArr={state.heightArr} />
				</Table>
				<Text style={styles.text}>
					{
						"Most parameters are trivial to be found. (If you cannot find your authorization and client_id, please check "
					}
					<TouchableOpacity onPress={() => this.props.onPress(2)}>
						<View>
							<Text style={styles.hyperlink}>
								{
									"here"
								}
							</Text>
						</View>
					</TouchableOpacity>
					{
						".) The only confusing parameter is the <entity>."
					}
				</Text>
				<Text style={[styles.text, { paddingBottom: 20 }]}>
					{
						"Following is an example of an <entity>. It is basically a JSON containing tables and values you are going to save."
					}
				</Text>
				<View style={styles.border}>
					<Text style={[styles.text, { paddingLeft: 90, paddingBottom: 20 }]}>
						{
							'{'
							+ "\n"
							+ '     	"employeepic": {'
							+ "\n"
							+ '            	"values": [ ]'
							+ "\n"
							+ '     	},'
							+ "\n"
							+ '     	"employee_attach": {'
							+ "\n"
							+ '            	"values": [ ]'
							+ "\n"
							+ '     	},'
							+ "\n"
							+ '     	"employee": {'
							+ "\n"
							+ '            	"values": ['
							+ "\n"
							+ '     		     	{"code": "000171","desc": "abcd"}'
							+ "\n"
							+ '            	]'
							+ "\n"
							+ '     	}'
							+ "\n"
							+ '}'
						}
					</Text>
				</View>
				<Text style={styles.text}>
					{
						"By making use of <Data Dictionary> provided in M18, you can get all the table information of the Module you need. " +
						"We need to fill in table <Sales Order> and <S.O. (Product)>."
					}
				</Text>
				<Image source={images.ch4_fig1} style={{ width: 1139, height: 345 }} />
				<Text style={[styles.text, { fontWeight: 'bold' }]}>
					{
						"<Sales Order> (mainso)"
					}
				</Text>
				<Image source={images.ch4_fig2} style={{ width: 1257, height: 388 }} />
				<Text style={[styles.text, { paddingBottom: 20 }]}>
					{
						"In order to save a SqlEntity successfully, we must at least input all the required fields marked. All other fields are optional."
					}
				</Text>
				<View style={styles.border}>
					<Text style={[styles.text, { paddingLeft: 90, paddingBottom: 20 }]}>
						{
							'{'
							+ "\n"
							+ '        "mainso": {'
							+ "\n"
							+ '                  "values": ['
							+ "\n"
							+ '                  	{'
							+ "\n"
							+ '                          "flowTypeId": 1,'
							+ "\n"
							+ '                          "code": "MYDEMOSO_001",'
							+ "\n"
							+ '                          "tDate": "2018-08-10 00:00:00",'
							+ "\n"
							+ '                          "cusId": 1,'
							+ "\n"
							+ '                          "curId": 2,'
							+ "\n"
							+ '                          "rate": 7.5,'
							+ "\n"
							+ '                          "staffId": 11'
							+ "\n"
							+ '                  	}'
							+ "\n"
							+ '                  ]'
							+ "\n"
							+ '        }'
							+ "\n"
							+ '}'
						}
					</Text>
				</View>
			</View>
		)
	}
}

class Content3 extends Component {
	render() {
		return (
			<View>
				<Text style={[styles.text, { fontWeight: 'bold' }]}>
					{
						"<S.O. (Product)> (sot)"
					}
				</Text>
				<Image source={images.ch4_fig3} style={{ width: 1205, height: 201 }} />
				<Text style={[styles.text, { paddingBottom: 20 }]}>
					{
						"Again, fill in the required fields first and then the optional fields."
					}
				</Text>
				<View style={styles.border}>
					<Text style={[styles.text, { paddingLeft: 90, paddingBottom: 20 }]}>
						{
							'{'
							+ "\n"
							+ '        "mainso": {'
							+ "\n"
							+ '                  "values": ['
							+ "\n"
							+ '                         "flowTypeId": 1,'
							+ "\n"
							+ '                         "code": "MYDEMOSO_001",'
							+ "\n"
							+ '                         "tDate": "2018-08-10 00:00:00",'
							+ "\n"
							+ '                         "cusId": 1,'
							+ "\n"
							+ '                         "curId": 2,'
							+ "\n"
							+ '                         "rate": 7.5,'
							+ "\n"
							+ '                         "staffId": 11'
							+ "\n"
							+ '                  ]'
							+ "\n"
							+ '        },'
							+ "\n"
							+ '        "sot": {'
							+ "\n"
							+ '                  "values": ['
							+ "\n"
							+ '                         {'
							+ "\n"
							+ '                                "proId": 1,'
							+ "\n"
							+ '                                "unitId": 2,'
							+ "\n"
							+ '                                "qty": 10'
							+ "\n"
							+ "                         },"
							+ "\n"
							+ '                         {'
							+ "\n"
							+ '                                "proId": 2,'
							+ "\n"
							+ '                                "unitId": 3,'
							+ "\n"
							+ '                                "qty": 7'
							+ "\n"
							+ '                         }'
							+ "\n"
							+ '                  ]'
							+ "\n"
							+ '        }'
							+ "\n"
							+ '}'
						}
					</Text>
				</View>
				<Text style={styles.text}>
					{
						"Now you should be ready to submit your request."
					}
				</Text>
				<Text style={[styles.text, { paddingBottom: 20 }]}>
					{
						"Back to the scenario, Chris integrates the Online Shop with M18 Web Service."
					}
				</Text>
			</View>
		)
	}
}

class Content4 extends Component {
	render() {
		return (
			<View>
				<Text style={styles.text}>
					{"When an order is confirmed, below HTTP request is send to M18 ERP System. Sales Order is saved automatically."}
				</Text>
			</View>
		)
	}
}

const styles = StyleSheet.create({
	heading: {
		paddingTop: 20,
		fontSize: 30,
		fontWeight: 'bold',
	},
	subheading: {
		paddingTop: 20,
		fontSize: 20,
		fontWeight: 'bold',
	},
	text: {
		paddingTop: 20,
	},
	hyperlink: {
		fontStyle: 'iTalic',
		color: 'blue',
		textDecorationLine: 'underline',
	},
	tableText: {
		margin: 6,
		fontSize: 10
	},
	tableCell: {

	},
	border: {
		borderWidth: 1,
	},
});

export { Content1, Content2, Content3, Content4 };



// WEBPACK FOOTER //
// ./src/pages/ch4/Content.js